import { FilterDefinitionDTO } from "../DTO/filterDefinitionDTO";
import { ValidationDefinitionDTO } from "../DTO/validationDefinitionDTO";
import { FileDefinition } from "./fileDefinition";
import { FilterProtocol } from "./filterProtocol";
import { FilterRuleDefinition } from "./filterRuleDefinition";
import { ValidationProtocol } from "./validationProtocol";
import { ValidationRuleDefinition } from "./validationRuleDefinition";

export class ValidationDefinition{

    public id!: number;
    public name!: string;
    public description!: string;
    public fileDefinition!: FileDefinition;
    public validationProtocols!: ValidationProtocol[];
    public version!: number; //incremental version number set by server
    public published!: boolean; //if true, then can be used for moovs and can be loaded by other users
    public added!: Date;
    public deleted!: boolean;
    public ownedByEntityId!: number;
    public ownerEntityType!: string;

    constructor(){
        this.validationProtocols = new Array();
    }

    public setFileDefinition(fd:FileDefinition){
        //use this method to correctly instantiate the protocols
        this.fileDefinition=fd;
        if(fd) this.validationProtocols.forEach(p=>p.createInputField(fd.fieldDefinitions));
    }

    public static mapFromDTO(param:ValidationDefinitionDTO):ValidationDefinition{ 
        if (!param) throw new Error("parameter is null")
        let obj = new ValidationDefinition();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.description = param.description;
            obj.validationProtocols = param.validationProtocols.map(vp=>ValidationProtocol.mapFromDTO(vp));
            obj.version = param.version;
            obj.published = param.published;
            obj.added = new Date(param.added);
            obj.deleted = param.deleted;
            obj.ownedByEntityId = param.ownedByEntityId;
            obj.ownerEntityType = param.ownerEntityType;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:ValidationDefinition):ValidationDefinitionDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new ValidationDefinitionDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.description = param.description;
            dto.fileDefinitionId = param.fileDefinition.id!;
            dto.validationProtocols = param.validationProtocols.map(vp=>ValidationProtocol.mapToDTO(vp));
            dto.version = param.version;
            dto.published = param.published;
            if(param.added) dto.added = param.added.toISOString();
            dto.deleted = param.deleted;
            dto.ownedByEntityId = param.ownedByEntityId;
            dto.ownerEntityType = param.ownerEntityType;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    get status():string{
        return this.deleted?"Inactive":"Active";
    }

    //use DTO to create a deep copy
    get clone():ValidationDefinition{
        //memorize used filterRuleDefinitions first
        let usedValidationRuleDefinitions:ValidationRuleDefinition[]=[];
        this.validationProtocols.forEach(vp=>{
            vp.validationRules.forEach(vr=>{
                if(usedValidationRuleDefinitions.findIndex(vrd=>vrd.id==vr.validationRuleDefinition.id)==-1){
                    usedValidationRuleDefinitions.push(vr.validationRuleDefinition);
                }
            });
        });
        let mappedValidationDefinition=ValidationDefinition.mapToDTO(this);
        mappedValidationDefinition.id=0;
        mappedValidationDefinition.name="";
        mappedValidationDefinition.version=0;
        mappedValidationDefinition.description="";
        mappedValidationDefinition.published=false;
        mappedValidationDefinition.validationProtocols.forEach(p=>{
            p.id=0;
            p.validationRules.forEach(r=>{
                r.id=0;

            });
        });
        let mapFromDTOValidationDefinition = ValidationDefinition.mapFromDTO(mappedValidationDefinition);
        mapFromDTOValidationDefinition.setFileDefinition(this.fileDefinition);
         //relate validationRuleDefinitions with clone
         mapFromDTOValidationDefinition.validationProtocols.forEach(vp=>{
            vp.validationRules.forEach(vr=>{
                vr.validationRuleDefinition=usedValidationRuleDefinitions.find(vrd=>vrd.id==vr.validationRuleDefinitionId)!;
            });
        });
        return mapFromDTOValidationDefinition;
    }

    public resetIds(){
        this.id=0;
        this.validationProtocols.forEach(p=>{
            p.id=0;
            p.validationRules.forEach(r=>r.id=0);
        });
    }

    get acceptFileTypes(){
        let types=".txt";
        if(this.fileDefinition?.type=='csv') types+=",.csv,.xml";
        return types
    }
}